
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.649 19.755a.545.545 0 01-.525-.476c-.385-2.4-2.558-6.588-8.071-6.833v3.08a.575.575 0 01-.289.506.504.504 0 01-.553-.043l-7.988-6.1A.583.583 0 010 9.424c0-.184.083-.357.223-.464l7.988-6.1a.504.504 0 01.553-.043.575.575 0 01.289.507V6.45c3.408.363 9.129 2.993 9.129 12.735 0 .297-.213.544-.489.568a.51.51 0 01-.044.002z","fill":"#748190"}})])
          )
        }
      }
    